/** Independent opt-ins: absence is off, and truthy values are not consent. */
export const validateHistoryConsent = (
  downloadMessages: unknown,
  analyze: unknown,
): string[] => {
  if (
    (downloadMessages !== undefined && typeof downloadMessages !== "boolean") ||
    (analyze !== undefined && typeof analyze !== "boolean")
  ) {
    return ["downloadMessages и анализ должны быть boolean (true/false)"]
  }
  return analyze === true && downloadMessages !== true
    ? [
        "analysis-requires-history-download: для анализа явно разрешите скачивание истории",
      ]
    : []
}

export const serializeHistoryConsent = (
  downloadMessages: unknown,
  analyze: unknown,
): { downloadMessages: boolean; analyze: boolean } => {
  const errors = validateHistoryConsent(downloadMessages, analyze)
  if (errors.length) throw new Error(errors.join("\n"))
  return {
    downloadMessages: downloadMessages === true,
    analyze: analyze === true,
  }
}
